import { defineStore } from 'pinia'

export const Documents = defineStore('zn_docs', {
    state: () => {
        return { zn_docs: null }
    },
    actions: {
        get() {
            return this.zn_docs
        },
        set(data) {
            this.zn_docs = data
        }
    },
})

export const OriginalDocuments = defineStore('zn_docs_o', {
    state: () => {
        return { zn_docs_o: null }
    },
    actions: {
        get() {
            return this.zn_docs_o
        },
        set(data) {
            this.zn_docs_o = data
        }
    },
})

export const SelectedDocs = defineStore('zn_selected_docs', {
    state: () => {
        return { zn_selected_docs: [] }
    },
    actions: {
        get() {
            return this.zn_selected_docs
        },
        set(data) {
            this.zn_selected_docs = data
        }
    },
})